import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
} from "./ui/select";
import { Client } from "@/redux/clients/types/Clients.interface";

interface SubsSelectorProps {
  companies: Client[];
  selectedCompanies: Client[];
  onChange: (value: string) => void;
  searchTerm?: string;
}

export const SubsSelector = ({
  companies,
  selectedCompanies,
  onChange,
  searchTerm = "",
}: SubsSelectorProps) => {
  return (
    <Select onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <span className="text-sm text-muted-foreground">
          Añade otra compañía
        </span>
      </SelectTrigger>
      <SelectContent
        position="popper"
        className="max-h-[350px] overflow-y-auto"
      >
        <SelectGroup>
          <SelectLabel>Compañías</SelectLabel>
          {[...companies]
            .filter(
              (company) =>
                company.nombre &&
                company.nombre.toLowerCase().includes(searchTerm.toLowerCase()),
            )
            .sort((a, b) => a.nombre.localeCompare(b.nombre))
            .map((company) => {
              const isSelected = selectedCompanies.some(
                (selectedCompany) => selectedCompany.id === company.id,
              );
              return (
                <SelectItem
                  value={company.id.toString()}
                  key={company.id}
                  isSelected={isSelected}
                >
                  <div className="flex justify-between items-center w-full">
                    <span>
                      {company.nombre} [{company.numeroCliente}]
                    </span>
                  </div>
                </SelectItem>
              );
            })}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
